import React from "react";

const Header = () => {
  return (
    <div
      style={{
        backgroundAttachment: "fixed",
        backgroundImage:
          "radial-gradient(rgba(0,0,0,0.6), rgba(0,0,0,1)), url(https://uploads-ssl.webflow.com/5e7ff3ec0c4ef4c974fa99e3/5e83f98bae1ad80129fcd7e5_wu-jianxiong-UniC8xhlzaE-unsplash.jpg)",
      }}
      className="h-screen w-screen bg-center bg-cover flex items-center"
    >
      <div className="container mx-auto">
        <h1 className="text-center font-bold text-5xl sm:text-7xl md:text-8xl">
          <span className="text-red-500">Redd</span>
          <span className="text-gray-200">Wings</span>
        </h1>
        <h2 className="text-gray-200 text-center text-lg sm:text-2xl md:text-3xl text-uppercase mt-2 sm:mt-4 font-semibold">
          Air Hostess & Hospitality Training Institute
        </h2>
      </div>
    </div>
  );
};

export default Header;
